<template>
    <div class="bg-light d-flex flex-column flex-1 overflow-hidden">
        <header class="bg-white d-flex flex-row justify-content-between align-items-center">
            <div class="d-flex flex-row align-items-center p-2">
                <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn" @click="$router.back();"><i class="mdi mdi-arrow-left"></i></a>
                <img :src="data.image" class="me-3" style="border-radius: 50%; width: 2.5em; height: 2.5em" v-if="data.image">
                <h5 class="m-0">{{data.name}}</h5>
            </div>
            <div class="d-flex flex-row px-3">
                <select v-if="Object.keys(data).length > 1 && !data_loading" class="form-select fw-600 text-muted me-2 w-auto" v-model="filter.m">
                  <option :value="month" v-for="month in 12" :key="month">{{format('2020-'+month+'-1')}}</option>
                </select>
                <select v-if="Object.keys(data).length > 1 && !data_loading" class="form-select fw-600 text-muted" v-model="filter.y">
                    <option :value="year(i)" v-for="i in 3" :key="i">{{year(i)}}</option>
                </select>
            </div>
        </header>
        <div class="performance px-2" :class="{'show':show_contract}" ref="performance">     
            <div class="d-flex flex-column position-relative bg-white w-100 h-100" v-if="Object.keys(data).length > 1 && !data_loading">
                <div class="position-absolute w-100 h-100 overflow-auto">
                    <div class="container bg-light" :class="!data.hasOwnProperty.call(data, 'marketing_header') ? 'py-3' : 'pt-1 pb-2'">

                        <div class="card mb-3" v-if="data.hasOwnProperty.call(data, 'group')">
                            <div class="card-header" style="background: var(--primary-color); border: 0;">
                                <h5 class="card-title text-white my-2">Group Target</h5>
                            </div>
                            <div class="card-body p-0" v-for="(g, gi) in data.group" :key="gi">
                                <div class="row no-gutters mx-2 my-1" v-if="g.hasOwnProperty.call(g, 'title')">
                                    <div class="col-12">
                                        <h6 class="card-title title-sep">{{g.title}}</h6>
                                    </div>
                                    <div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-2" v-if="g.hasOwnProperty.call(g, 'base_incentive')">
                                        Base Incentive: <p class="m-0 fs-16 fw-600 base-incentive">{{g.base_incentive}}</p>
                                    </div>
                                    <div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-2" v-if="g.hasOwnProperty.call(g, 'revenue_contract')">
                                        Revenue: <b class="ms-1 gp-perc" v-if="g.revenue_perc > 0">{{g.revenue_perc}}%</b> 
                                        <p class="m-0 fs-16 fw-600 revenue-target d-block">{{g.revenue_contract}}</p>
                                    </div>
                                    <div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-2" v-if="g.hasOwnProperty.call(g, 'gp_contract')">
                                        GP: <b class="ms-1 gp-perc" v-if="g.gp_perc > 0">{{g.gp_perc}}%</b> 
                                        <p class="m-0 fs-16 fw-600 gp-target d-block">{{g.gp_contract}}</p>
                                    </div>
                                </div>
                                
                                <div class="w-100" v-if="g.hasOwnProperty.call(g, 'remarks')">
                                    <pre class="py-2 px-3 bg-white" style="font-family: inherit;">
{{g.remarks}}
                                    </pre>
                                </div>
                            </div>
                            <div class="card-footer p-2 text-end"  v-if="data.hasOwnProperty.call(data, 'group')">
                                <button class="btn btn-primary fw-600" v-if="data.group.status !== 'FWD'" @click="$emitter.emit('contract_confirm', acceptGroupContract)">Accept Contract</button>
                                <button class="btn fw-600" disabled v-else>Accepted</button>
                            </div>
                        </div>

                        <div class="card" style="border-radius: 5px;" v-if="typeof data.contract !== 'undefined' && Object.keys((typeof data.contract !== 'undefined' ? data.contract : {})).length > 0">
                            <div class="card-header" style="background: var(--primary-color); border: 0;">
                                <h5 class="card-title text-white my-2">
                                    <i class="mdi mdi-information"></i> {{data.contract.month}} Contract</h5>
                            </div>
                            <div class="card-header p-0 bg-white" v-if="Object.keys(data.contract.target).length">
                                <div class="row no-gutters mx-2 my-1" v-for="(target, gci) in data.contract.target" :key="gci">
                                    <div class="col-12">
                                        <h6 class="card-title title-sep">{{target.title}}</h6>
                                    </div>
                                    <div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-2">
                                        Base Incentive: 
                                        <p class="m-0 fs-16 fw-600 base-incentive">{{target.base_incentive}}</p>
                                    </div>
                                    <div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-2">
                                        Revenue Target: <b class="ms-1 revenue-perc" v-if="target.revenue_perc > 0">{{target.revenue_perc}}%</b> 
                                        <p class="m-0 fs-16 fw-600 revenue-target d-block">{{target.revenue_contract}}</p>
                                    </div>
                                    <div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-2">
                                        GP Target:  <b class="ms-1 gp-perc" v-if="target.gp_perc > 0">{{target.gp_perc}}%</b> 
                                        <p class="m-0 fs-16 fw-600 gp-target d-block">{{target.gp_contract}}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card-header p-0 bg-white" v-if="data.contract !== undefined && Object.keys(data.contract).length">
                                <div class="row no-gutters mx-2 my-1" v-if="data.contract.hasOwnProperty.call(data.contract, 'products')">
                                    <div class="col-12" v-if="Object.keys(data.contract.products).length">
                                        <h6 class="card-title title-sep">Brand Revenue Target</h6>
                                    </div>
                                    <div class="col-12" v-for="(prod, pindex) in data.contract.products" :key="pindex">
                                        <div class="row no-gutter g-2">
                                            <div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-2" v-for="(pr, prindex) in prod" :key="prindex">
                                                <small>{{pr.name}}</small>  
                                                <b class="ms-2 fs-13">{{(pindex == 'i' ? pr.perc : (prindex == prod.length - 1 ? `Total Print: ${pr.total_perc}`: ''))}}</b> <p class="m-0 fs-16 fw-600 revenue-target d-block">{{pr.target_amount}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-body p-0" v-if="data.contract.hasOwnProperty.call(data.contract, 'terms')">
                                <pre class="py-2 px-3 bg-white" style="font-family: inherit;">
{{data.contract.terms}}
                                </pre>
                            </div>
                           
                            <div class="card-footer p-2 text-end" v-if="data.contract !== undefined && Object.keys(data).length">
                                <button class="btn btn-primary fw-600" v-if="data.contract.status !== 'FWD'" @click="$emitter.emit('contract_confirm', acceptContract)">Accept Contract</button>
                                <button class="btn fw-600" disabled v-else>Accepted</button>
                            </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 mt-2" style="min-height: 300px;" v-else-if="data.contract == undefined">
                            <i class="mdi mdi-newspaper-variant-outline h-auto opacity-3" style="font-size: 100px;"></i>
                            <span class="fw-500 opacity-3">Loading Contract</span>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 mt-2" style="min-height: 300px;" v-else-if="!data.group && !Object.keys(data.contract).length">
                            <i class="mdi mdi-newspaper-variant-outline h-auto opacity-3" style="font-size: 100px;"></i>
                            <span class="fw-500 opacity-3">No Contract found</span>
                        </div>

                        <h4 class="mt-5 mb-4 main-title">Performance Management</h4>

                        <div class="row row-cols-2 row-cols-md-4 g-2" v-if="data.hasOwnProperty.call(data, 'header')">
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">GP Target</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.header !== undefined ? data.header[0] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">GP Achievement</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.header !== undefined ? data.header[1] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">Revenue Target</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.header !== undefined ? data.header[2] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">Revenue Achievement</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.header !== undefined ? data.header[3] : '')}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row row-cols-2 row-cols-md-4 g-2" v-if="data.hasOwnProperty.call(data, 'marketing_header')">
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">Revenue</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_header !== undefined ? data.marketing_header[0] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">GP</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_header !== undefined ? data.marketing_header[1] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">Inventory</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_header !== undefined ? data.marketing_header[2] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">DIO (Days)</h6>
                                    <small class="fs-14 mb-2">{{data.name}}</small>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_header !== undefined ? data.marketing_header[3] : '')}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 mt-2" v-if="data.hasOwnProperty.call(data, 'marketing_group_header')">
                            <div class="col-12">
                                <h4 class="main-title">Group Performance</h4>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">Revenue</h6>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_group_header !== undefined ? data.marketing_group_header[0] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">GP</h6>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_group_header !== undefined ? data.marketing_group_header[1] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">Inventory</h6>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_group_header !== undefined ? data.marketing_group_header[2] : '')}}</h3>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div class="card card-body bg-white">
                                    <h6 class="text-truncate fw-700 mb-0 fs-18">DIO (Days)</h6>
                                    <h3 class="fw-700 fs-1 d-block text-center">{{(data.marketing_group_header !== undefined ? data.marketing_group_header[3] : '')}}</h3>
                                </div>
                            </div>
                        </div>

                         <div class="row row-cols-1 row-cols-md-2 g-2 mt-1" v-if="data.hasOwnProperty.call(data, 'table')">
                             <div class="col" v-for="(t, tindex) in data.table" :key="tindex">
                                 <div class="card card-body p-0 bg-white">
                                    <h6 class="text-truncate m-3 fw-700 fs-16">{{t.title}}</h6>

                                    <div class="table-responsive">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="fw-600 border-bottom bg-light border-top" :class="{'text-end':thindex > 0}" v-for="(th, thindex) in t.headings" :key="thindex">{{th}}</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="t.body.length">
                                                <tr v-for="(tb, tbindex) in t.body" :key="tbindex">
                                                    <td class="text-muted" v-for="(d, dindex) in tb" :key="dindex" :class="{'text-end':dindex > 0, 'fw-600': dindex == 0}">{{d}}</td>
                                                </tr>
                                            </tbody>
                                            <div class="position-absolute d-flex w-100 h-100 flex-column text-muted p-3" v-else>
                                                No data found
                                            </div>
                                        </table>
                                    </div>
                                 </div>
                             </div>
                         </div>

                         <div class="row row-cols-1 row-cols-lg-3 g-2 mt-1" v-if="data.hasOwnProperty.call(data, 'chart')">
                             <div class="col" v-for="(c, cindex) in data.chart" :key="cindex">
                                 <div class="card card-body p-0 bg-white">
                                    <h6 class="text-truncate m-3 fw-700 fs-16">{{c.title}}</h6>
                                    <apexcharts :width="c.width" :height="c.height" :type="c.type" :options="c.options" :series="c.series"></apexcharts>
                                 </div>
                             </div>
                         </div>

                        <div v-if="data.hasOwnProperty.call(data, 'linec')">
                            <div class="card card-body mt-2 p-0 bg-white" v-for="(lc, lcindex) in data.linec" :key="lcindex">
                                <h6 class="text-truncate m-3 fw-700 fs-16">{{lc.title}}</h6>

                                <apexcharts :width="lc.width" :height="lc.height" :type="lc.type" :options="lc.options" :series="lc.series" v-if="lc.series !== undefined"></apexcharts>
                            </div>
                        </div>

                        <div v-if="data.tablep !== undefined">
                            <div class="card card-body mt-2 p-0 bg-white card-product" v-for="(tp, tpindex) in data.tablep" :key="tpindex">
                                <h6 class="text-truncate m-3 fw-700 fs-16">{{tp.title}}</h6>

                                <table class="table table-hover table-bordered table-striped position-relative h-100 table-stick" v-for="(tp, tpindex) in data.tablep" :key="tpindex">
                                    <thead>
                                        <th class="fw-500 text-muted border-bottom" :class="{'text-end': tphindex > 0}" v-for="(tph, tphindex) in tp.headings" :key="tphindex">
                                            <p class="m-0" :class="{'text-end': tphindex > 0}" v-html="tph"></p>
                                        </th>
                                    </thead>
                                    <tbody v-if="tp.body.length">
                                        <tr v-for="(tpb, tpbindex) in tp.body" :key="tpbindex">
                                            <td class="text-muted" :class="(tpbbindex > 0 ? 'text-end fw-500 text-black-50' : 'fw-600')" v-for="(tpbb, tpbbindex) in tpb" :key="tpbbindex">{{tpbb}}</td>
                                        </tr>
                                    </tbody>
                                    <div class="position-absolute d-flex w-100 h-100 flex-column text-muted p-3" v-else>
                                        No data found
                                    </div>
                                </table>
                            </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 mt-2" style="min-height: 300px;" v-else>
                            <i class="mdi mdi-chart-box-outline h-auto opacity-3" style="font-size: 100px;"></i>
                            <span class="fw-500 opacity-3">Data is being generated</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 opacity-3" v-else-if="data_loading">
                <i class="mdi mdi-chart-box-outline h-auto" style="font-size: 100px;"></i>
                <span class="fw-500">Data is being generated</span>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center bg-white w-100 h-100 opacity-3" v-else>
                <i class="mdi mdi-close-circle h-auto" style="font-size: 100px;"></i>
                <span class="fw-500">You do not have permission to view this page</span>
            </div>
        </div>
    </div>

    <ConfirmContractModal />
</template>

<script>
import moment from 'moment';
import VueApexCharts from 'vue3-apexcharts'
import ConfirmContractModal from './modal/ContractConfirmModal';

export default {
    components: {
        apexcharts: VueApexCharts,
        ConfirmContractModal
    },
    data() {
        return {
            barchart_options: {
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                            horizontal: false,
                            columnWidth: '90%',
                            dataLabels: {
                            position: 'top', // top, center, bottom
                        }
                    },
                },
                yaxis: {
                    show: true,
                    labels: {
                        formatter: (val) => {
                            return this.number_format(parseFloat(val).toFixed(0));
                        }
                    },
                },
                dataLabels: {
                        enabled: true,
                        offsetY: -20,
                        style: {
                        fontSize: '12px',
                        colors: ["#333333"]
                    },
                    formatter: (val) => {
                        return this.number_format(parseFloat(val).toFixed(0));
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: ['Target', 'Actual']
                }
            },
            linechart_options: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false,
                        autoScaleXaxis: false
                    },
                },
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        return this.KFormatter(val);
                    }
                },
                stroke: {
                    curve: 'smooth'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    enabled: true,
                    categories: []
                },
                yaxis: {
                    show: true,
                    labels: {
                        formatter: (val) => {
                            return this.KFormatter(val);
                        }
                    },
                },
                legend: {
                    show: true,
                },
                tooltip: {
                    y: {
                        formatter: (val) => {
                            return this.number_format(parseFloat(val).toFixed(0));
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                },
            },
            filter: {
                m: moment().format('M'),
                y: moment().format('YYYY')
            },
            needLoad: [
                ['', 'salesman'],
                ['header', 'header'],
                ['table', 'hubspot_matrix'],
                ['chart', 'ermhubspot_chart'],
                ['linec', 'erm_morev'],
                ['linec', 'erm_mogp'],
                ['tablep', 'erm_prodsupp'],
                ['contract', 'contract'],
                ['group', 'group']
            ],
            marketingLoad: [
                ['', 'salesman'],
                ['header', 'marketing_header'],
                ['tablep', 'marketing_tablep'],
            ],
            data: {
                linec: [],
            },
            data_loading: true,
            show_contract: false,
        }
    },
    methods: {
        async acceptContract() {
            await this.$axios.post('/contract', this.$qs.stringify({y:this.filter.y,m:this.filter.m,id:this.$route.params.salesman_code}))
                    .then((res) => {
                        if(res.status == 200) this.data.contract.status = 'FWD';
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
        },
        async acceptGroupContract() {
            await this.$axios.post('/contract/group', this.$qs.stringify({y:this.filter.y,m:this.filter.m,id:this.$route.params.salesman_code}))
                    .then((res) => {
                        if(res.status == 200) this.data.contract.status = 'FWD';
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
        },
        getmonth() {
            return moment().format('MMMM');
        },
        load() {
            this.data_loading = true;
            this.needLoad.forEach(element => {
                this.loadData(element);
            });
        },
        async loadData(type) {
            await this.$axios.post(`/performance/${type[1]}/${this.$route.params.salesman_code}`, this.$qs.stringify(this.filter))
                    .then((res) => {
                        // if(type[0] == '') this.data = res.data;
                        // console.log(this.data);
                        if(res.data.length || Object.keys(res.data).length) {

                            switch(type[0]) {
                                case "chart":
                                    res.data.chart.forEach(element => {
                                        element['options'] = this.barchart_options;
                                    });
                                    Object.assign(this.data, res.data);     

                                    break;
                                default:
                                    Object.assign(this.data, res.data);
                                    break;
                                case "linec":
                                    var opt = this.linechart_options;
                                    opt.xaxis.categories = res.data.categories;
                                    res.data['options'] = opt;
                                    delete res.data.categories;
                                    this.data.linec.push(res.data);
                                    break;
                                    
                            }
                        }
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.data_loading = false;
        },
        KFormatter(num) {
            const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
            const tier = Math.floor(Math.log10(num) / 3) || 0;
            let result = '' + num;
            // if zero, we don't need a suffix
            if (tier > 0) {
                // get suffix and determine scale
                const suffix = SI_SYMBOL[tier];
                const scale = Math.pow(10, tier * 3);
                // scale the number
                const scaled = num / scale;
                // format number and add suffix
                result = scaled.toFixed(1).replace('.0', '') + suffix;
            }
            return result;
        },
        number_format(number) {
            return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        year(minus = 0) {
            minus -= 1;
            return moment().subtract(minus, "years").format('YYYY');
        },
        format(date = '') {
            return moment(new Date(date)).format('MMMM');
        },
        toggleClose() {
            let main = this.$refs.performance;
            if(main !== undefined) {
                this.show_contract = !main.classList.contains('show');

                if(main.classList.contains('show')) main.classList.remove('show');
                else main.classList.add('show');
            }
        },
        reset() {
            this.data_loading = true;
            this.data = {
                linec: [],
            };
        }
    },
    activated() {
        if(this.$route.params.salesman_code == undefined) this.$router.replace('/error');
        this.load();
    },
    deactivated() {
        this.show_contract = false;
        this.reset();
    },
    watch: {
        "filter.y": function() {
            this.reset();
            this.load();
        },
        "filter.m": function() {
            this.reset();
            this.load();
        },
        data:{
            handler(val) {
                if(val.name !== undefined) window.document.title = `${val.name} Performance - ${process.env.VUE_APP_APPNAME}`;
            },
            deep: true
        }
    }
}
</script>

<style scoped>

.chart, .table-responsive {
    min-height: 300px;
}

pre {
     white-space: pre-wrap;       /* css-3 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}

.performance {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: row;
    height: 100%;
}

.performance.show aside {
    left: 0;
    width: 40vw;
}

.performance aside {
    left: -40vw;
    width: 0;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    background: #fff;
    position: relative;
    transition: 0.3s ease;
    border-right: 1px solid rgb(245 245 245);
}

.container {
    max-width: 100%;
}

.profile-card {
    width: 100%;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.bg-primary {
    background-color: var(--sub-color) !important;
}

@media screen and (max-width: 767px) {
    /* .performance.show .aside {
        left: 0;
    }

    .performance aside {
        position: absolute;
        z-index: 999;
        width: 100vw !important;
        left: -100vw;
        height: calc(100vh - 160px) !important;
    } */

    .card-product {
        overflow-x: auto;
        overflow-y: hidden;
    }

    .card-product thead th {
        white-space: nowrap;
    }
}

.list-group-item {
    border-bottom: 1px solid rgb(245 245 245);
}

table.table-stick {
    text-align: left;
    border-collapse: collapse; 
}

table.table-stick th {
    background: white;
    position: sticky;
    top: -1px; /* Don't forget this, required for the stickiness */
    margin-top: -1px;
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;
}

.title-sep {
    background: #6696e82e;
    border-radius: 4px;
    padding: 6px 4px;
}

.main-title {
    background: var(--primary-color);
    border-radius: 4px;
    padding: 10px;
    font-size: 1.2em;
    color: #ffffff;
}
</style>